import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import SchemaMarkup from '../../components/base/SchemaMarkup';

const contactSchema = [
  {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact MADLIENA Landmark Ltd - Redsail Laser Malta",
    "description": "Get in touch with MADLIENA Landmark Ltd for laser machine inquiries, quotes, and support in Malta.",
    "url": "https://redsaillaser-malta.com/contact",
    "mainEntity": {
      "@type": "LocalBusiness",
      "name": "MADLIENA Landmark Ltd",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "47, Triq il Gladjoli",
        "addressLocality": "Madliena",
        "addressCountry": "MT",
        "postalCode": "SWQ2023"
      },
      "telephone": "+356-9944-6552",
      "email": "grtrophy@gmail.com",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "18:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "10:00",
          "closes": "14:00"
        }
      ]
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://redsaillaser-malta.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Contact",
        "item": "https://redsaillaser-malta.com/contact"
      }
    ]
  }
];

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <SchemaMarkup schema={contactSchema} />
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <span className="text-emerald-500 font-semibold text-sm tracking-wider uppercase">
            Contact Us
          </span>
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mt-3 mb-6">
            Get In Touch
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Have questions about our laser machines? We're here to help. 
            Reach out to us and we'll respond as soon as possible.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Contact Information
            </h2>
            <p className="text-gray-600">
              Reach out to us through any of the following channels
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-gray-50 rounded-2xl p-8 flex items-start gap-4">
              <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-line text-xl text-emerald-500"></i>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">Address</h3>
                <p className="text-gray-600">
                  47, Triq il Gladjoli<br />
                  Madliena<br />
                  Malta SWQ2023
                </p>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 flex items-start gap-4">
              <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-phone-line text-xl text-emerald-500"></i>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">Phone</h3>
                <a
                  href="tel:+35699446552"
                  className="text-gray-600 hover:text-emerald-500 transition-colors"
                >
                  +356 9944 6552
                </a>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 flex items-start gap-4">
              <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-xl text-emerald-500"></i>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">Email</h3>
                <a
                  href="mailto:grtrophy@gmail.com"
                  className="text-gray-600 hover:text-emerald-500 transition-colors"
                >
                  grtrophy@gmail.com
                </a>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 flex items-start gap-4">
              <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-building-line text-xl text-emerald-500"></i>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">Company</h3>
                <p className="text-gray-600">
                  MADLIENA Landmark Ltd<br />
                  VAT No: MT 29045621
                </p>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Business Hours</h3>
              <div className="space-y-2 text-gray-600">
                <div className="flex justify-between">
                  <span>Monday - Friday</span>
                  <span className="font-semibold">9:00 AM - 6:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Saturday</span>
                  <span className="font-semibold">10:00 AM - 2:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Sunday</span>
                  <span className="font-semibold">Closed</span>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Follow Us</h3>
              <p className="text-gray-600 mb-4">Connect with us on social media</p>
              <div className="flex gap-3">
                <a
                  href="https://wa.me/35699446552"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-white rounded-full flex items-center justify-center hover:bg-emerald-500 hover:text-white transition-all shadow-sm cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                </a>
                <a
                  href="#"
                  className="w-12 h-12 bg-white rounded-full flex items-center justify-center hover:bg-emerald-500 hover:text-white transition-all shadow-sm cursor-pointer"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a
                  href="#"
                  className="w-12 h-12 bg-white rounded-full flex items-center justify-center hover:bg-emerald-500 hover:text-white transition-all shadow-sm cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Find Us on the Map
          </h2>
          <div className="rounded-2xl overflow-hidden shadow-lg h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3229.8!2d14.45!3d35.93!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzXCsDU1JzQ4LjAiTiAxNMKwMjcnMDAuMCJF!5e0!3m2!1sen!2smt!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="MADLIENA Landmark Ltd Location"
            ></iframe>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
